import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { Radio } from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import useTable from "../../../../components/useTable";

const headCells = [
  {
    id: "desbloquear",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Desbloquear",
    textAlign: "center",
  },
  {
    id: "codigo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Código",
    textAlign: "center",
  },
  {
    id: "nomina",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nomina",
    textAlign: "center",
  },
];

export default function DesbloquearRegistros({ show, setShow, setTabla }) {

  const [tableData, setTableData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
    
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    tableData,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Desbloquear Registros</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {tableData &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-auto m-0 mt-2 p-0 d-flex gap-2">
          <div className="col-auto m-0 p-0">
            <Radio label = 'Marcar Todos' name = 'marcar' id = 'marcar1'/>
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Desmarcar Todos' name = 'marcar' id = 'marcar2'/>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
